/**
 * @flow
 */

import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { Form, Input, Button } from 'semantic-ui-react';
import { defineMessages, injectIntl } from 'react-intl';

import ProductSelect from '../../../containers/cart/form/ProductSelect';
import QuantityField from './QuantityField';
import PaymentTypeField from '../../details/invoice/PaymentTypeField';

import type { Intl } from '../../../../../type';

const intlMessages = {
    item: defineMessages({
        placeholder: {
            id: 'pages.appointments.cart.form.product.placeholder',
            defaultMessage: 'Product',
        },
    }),
    quantity: defineMessages({
        placeholder: {
            id: 'pages.appointments.cart.form.quantity.placeholder',
            defaultMessage: 'Qty.',
        },
    }),
    price: defineMessages({
        placeholder: {
            id: 'pages.appointments.cart.form.price.placeholder',
            defaultMessage: 'Price',
        },
    }),
    paymentType: defineMessages({
        placeholder: {
            id: 'pages.appointments.cart.form.paymentType.placeholder',
            defaultMessage: 'Select payment type',
        },
    }),
};

type CartItemFieldsProps = {
    index: number,
    onRemove: Function,
    intl: Intl,
    paid: boolean,
};

const RemoveButton = styled(Button)`
    margin-right: 0px !important;
`;

function CartItemFields({ index, onRemove, intl, paid }: CartItemFieldsProps) {
    const { control, setValue } = useFormContext();
    const fieldPath = `items.${index}`;

    return (
        <Form.Group>
            <Controller
                name={`${fieldPath}.entity`}
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Form.Field width={paid ? 8 : 7}>
                        <ProductSelect
                            value={value}
                            onChange={(e, { value: v }) => onChange(v)}
                            paid={paid}
                            disabled={paid}
                            change={(name, val) => setValue(name, val)}
                            name={`${fieldPath}.entity`}
                            fluid
                            search
                            placeholder={intl.formatMessage(
                                intlMessages.item.placeholder,
                            )}
                        />
                    </Form.Field>
                )}
            />
            <Controller
                name={`${fieldPath}.quantity`}
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Form.Field width={2}>
                        <QuantityField
                            value={value}
                            onChange={(e, { value: v }) => onChange(v)}
                            name={`${fieldPath}.quantity`}
                            disabled={paid}
                            fluid
                            placeholder={intl.formatMessage(
                                intlMessages.quantity.placeholder,
                            )}
                        />
                    </Form.Field>
                )}
            />
            <Controller
                name={`${fieldPath}.price`}
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Form.Field width={2}>
                        <Input
                            value={value == null ? '' : value}
                            onChange={e => onChange(e.target.value)}
                            disabled={paid}
                            fluid
                            placeholder={intl.formatMessage(
                                intlMessages.price.placeholder,
                            )}
                        />
                    </Form.Field>
                )}
            />
            <Controller
                name={`${fieldPath}.paymentType`}
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Form.Field width={4}>
                        <PaymentTypeField
                            value={value}
                            onChange={(e, { value: v }) => onChange(v)}
                            disabled={paid}
                            fluid
                            placeholder={intl.formatMessage(
                                intlMessages.paymentType.placeholder,
                            )}
                        />
                    </Form.Field>
                )}
            />
            {!paid && (
                <Form.Field>
                    <RemoveButton
                        onClick={onRemove}
                        color="red"
                        icon="trash"
                        basic
                    />
                </Form.Field>
            )}
        </Form.Group>
    );
}

export default injectIntl(CartItemFields);
